// extracted by mini-css-extract-plugin
export default {"audio":"styles_audio__0WjIc","audioInfo":"styles_audioInfo__bGZ-5","title":"styles_title__YwKaR","time":"styles_time__aoPCm","delete":"styles_delete__KMAvQ"};